import React, { memo, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { BellIcon, MarkAsReadIcon, TickMark } from '../../AppIcons';
import { ConditionalBlock } from '../../ConditionalBlock';
import Constants from '../../Constants';
import icons from '../../icons';
import APIUrls from '../../services/APIUrls';
import {io} from 'socket.io-client';
import { getAxiosResponse, handleError, postAxiosResponse } from '../../services/authApiRoutes/APImethods';
import { useNavigate } from 'react-router-dom';
import DateFormat from "../../pages/DateFormat";
import {DATE_FORMATS} from "../../services/DateUtil";


function Notifications({}) {
   const navigate = useNavigate();
   const [notifications, setNotifications] = useState([]);
   const [yesterDay, setYesterDay] = useState([]);
   const [older, setOlder] = useState([]);
   const listInnerRef = useRef();
   const [currPage, setCurrPage] = useState(1);
   const [prevPage, setPrevPage] = useState(0);
   const [lastList, setLastList] = useState(false);
   const [onlyUnread, setOnlyUnread] = useState(false);
   const [refresh, setRefresh] = useState(false);
   const [openPopup, setOpenPopup] = useState(false);
   const [notificationCount, setNotificationCount] = useState(0);
   const [frontLabel, setFrontLabel] = useState("Today");
   const [isUnread, setUnread] = useState(true);
   const owner = useSelector((loginSessionDetail) => loginSessionDetail.loginSession).value;

   useEffect(()=>{
      const soc = io(process.env.REACT_APP_BACKEND_SERVER,{
         transports: ["websocket"] 
       });
      soc.emit("newUser",owner?.id);
      soc?.on('notification', (data)=>{
            if(data.count===1){
               getNotificationsCount();
            }
      });
   },[notificationCount,owner]);

   useEffect(()=>{
      if(openPopup === true){
         getData();
      }
      getNotificationsCount();
   },[onlyUnread,refresh,openPopup]);

   useEffect(()=>{
      if (!lastList && prevPage !== currPage) {
         getAllUnReadnotifications();
      }
   },[currPage, lastList]);

   const populateLabel = (data)=>{
      let label = "";
      if(data?.Today?.length>0){
         label = "Today";
      }else if(data?.Yesterday?.length>0){
         label = "Yesterday";
      }else if(data?.Older?.length>0){
         label = "Older";
      }else{
         label = "";
      }
      setFrontLabel(label);
   };

   const notificationClick = () => {
      setOpenPopup(!openPopup);
   };

   const getNotificationsCount = ()=>{
      getAxiosResponse(APIUrls.NOTIFICATIONS_COUNT)
      .then((response)=>{
        setNotificationCount(response.data.data);
      }).catch((err)=>{
         handleError(err);
      });
   };

   const getData = async()=>{
      await getAxiosResponse(APIUrls.NOTIFICATIONS+`?unread=${onlyUnread}&page=1`)
      .then((response)=>{
         const data = response.data.data;
         populateLabel(data);
         listInnerRef.current.scrollTo({top:0});
         setPrevPage(1);
         setCurrPage(1);
         setUnread(data?.unread);
         setLastList(false);
         if(data.Today !== undefined){
            setNotifications(data.Today);
         }else{
            setNotifications([]);
         }
         if(data.Yesterday !== undefined){
            setYesterDay(data.Yesterday);
         }else{
            setYesterDay([]);
         }
         if(data.Older !== undefined){
            setOlder(data.Older);
         }else{
            setOlder([]);
         }
      }).catch((err)=>{
         handleError(err);
      });
   };

   const getAllUnReadnotifications = ()=>{
      getAxiosResponse(APIUrls.NOTIFICATIONS+`?unread=${onlyUnread}&page=${currPage}`)
      .then((response)=>{
         const data = response.data.data;
         if(data){
            if (Object.keys(data).length === 0) {
               setLastList(true);
               return;
            }
            setPrevPage(currPage);
            setUnread(data?.unread);
            if(data.Today !== undefined){
               setNotifications([...notifications,...data.Today]);
            }
            if(data.Yesterday !== undefined){
               setYesterDay([...yesterDay,...data.Yesterday]);
            }
            if(data.Older !== undefined){
               setOlder([...older,...data.Older]);
            }
         }
      }).catch((err)=>{
         handleError(err);
      });
   };

   const onScroll = () => {
      if (listInnerRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
        if (Math.ceil(scrollTop + clientHeight) === (scrollHeight)) {
            if(!lastList){
               setCurrPage(currPage + 1);
            }
        }
      }
   };

   const NoDataFoundComponent = () => {
      return (
         <div role="rowgroup">
            <div role="row" className="no-data-display align-center">
               <div role="cell">
                  <i className="nodata-icon"></i>
                  <p>{Constants.NO_NOTIFICATION_FOUND}</p>
               </div>
            </div>
         </div>
      );
   };

   const AllData = () => {
      return (
         <div role="rowgroup">
            <div role="row" className="align-center">
               <div role="cell">
                  {TickMark}
                  <h4 className='title pb-0'>You're all caught up</h4>
                  <p> you've seen all notifications from past 30 days.</p>
               </div>
            </div>
         </div>
      );
   };

   window.addEventListener("click", ({ target }) => {
      const popup = target.closest(".notification");
      if (!popup) {
         setOpenPopup(false);
      }
    });

   const markAllAsRead = ()=>{
      postAxiosResponse(APIUrls.NOTIFICATIONS)
      .then((response)=>{
         setRefresh(refresh?false:true);
         setUnread(false);
      }).catch((err)=>{
         handleError(err);
      });
   };

   const markAsRead = (id,read,event,redirect)=>{
      if(read === false){
         postAxiosResponse(APIUrls.NOTIFICATIONS_BY_ID(id))
         .then((response)=>{
            setRefresh(refresh?false:true);
         }).catch((err)=>{
            handleError(err);
         });
      }
      if(redirect === true){
         const url = getRedirectUrl(event);
         if(url !== ""){
            navigate(url);
         }
      }
   };

   const getRedirectUrl = (event)=>{
      if(event !== undefined && event.entity !== undefined){
         switch(event.entityType){
            case 'project':
               return `/project/${event.entity.id}`;
            case 'workspace':
               return `/workspace/${event.entity.id}`;
         }
      }else{
         return "";
      }
      
   }

   const handleOnlyUnread = (e)=>{
      setOnlyUnread(e.target.checked)
   };

   const NotificationEvent = ({read,event,id,indx,isOlder})=>{
      return (
         <>
            <div key={indx+"-"+event?.id+"-t1"} className={read === false ?"notification-massage-list flex unread":"notification-massage-list flex"}>
               <GetInitials keyName={indx+"-"+event?.id+"-t2"} event={event}/>
               <div  key={indx+"-"+event?.id+"-t3"} className="notification-msg" onClick={()=>markAsRead(id,read,event,true)}>
                  <strong dangerouslySetInnerHTML={{__html: event.output}}></strong>
                  <p dangerouslySetInnerHTML={{__html: event.recentActivityVO.contextUrl}}></p>
                  <ConditionalBlock condition={isOlder === false}>
                     <small>
                        <DateFormat date={event?.createdDate} format={DATE_FORMATS.TIME_OF_DAY}/>
                     </small>
                  </ConditionalBlock>
                  <ConditionalBlock condition={isOlder === true}>
                     <small>
                        <DateFormat date={event?.createdDate} format={DATE_FORMATS.DATE_TIME} />
                     </small>
                  </ConditionalBlock>
               </div>
               <ConditionalBlock condition={read === false}>
                  <button className='notification-read' title="mark as read" onClick={()=>markAsRead(id,read,event,false)}>
                     {MarkAsReadIcon}
                  </button>
               </ConditionalBlock>
            </div>
         </>
      );
   };

   const GetInitials = ({keyName,event})=>{
      const creatorUser = event.creatorUser;
      let firstName = creatorUser.firstName.charAt(0).toUpperCase();
      let lastName = creatorUser.lastName.charAt(0).toUpperCase();
      return (
         <div key={keyName} className="notification-user" style={{background:'#FFE29D'}}>
               <strong>{creatorUser.firstName ==="System" ? <img src={icons.OPAL_ICON} alt="Logo"></img>:(firstName+lastName)}</strong>
         </div>
      );
   };

   return (
    <>
      <div className={!openPopup ? "notification" : "notification open"}>
         <div tabIndex="0" aria-label={{notificationCount}+" Notifications"}  role="button" aria-expanded={openPopup} onClick={notificationClick}>
            {BellIcon}
            <ConditionalBlock condition={notificationCount>0}>
               <span>{notificationCount>9?"9+":notificationCount}</span>
            </ConditionalBlock>
            <div className="triangle-with-shadow"></div>
         </div>
         
            <div className="popover-body">
               <div className="inner-popover" id="notif-scroll" onScroll={()=>onScroll()} ref={listInnerRef}>
                  <div className="notification-header flex">
                     <h6>Notifications</h6>
                     <div className="form-switch flex">
                        <label className="form-check-label" htmlFor="markUnread">Only show unread</label>
                        <input type="checkbox" id='markUnread' role="switch" className="switch" onChange={(e)=>handleOnlyUnread(e)}/>
                     </div>
                  </div>
                  <ConditionalBlock condition={notifications?.length>0 || yesterDay?.length>0 || older?.length>0}>
                     <div >
                        {/*<ul className="flex notification-tab">
                           <li><button className="active">All</button></li>
                           <li><button>Assigned to me</button></li>
                        </ul>*/}

                        <div className='presentday-content'>
                           <div className='flex presentday-top-block'>
                              <div className='notification-days'>
                                 {frontLabel} {isUnread === true}
                              </div>
                              <ConditionalBlock condition={isUnread === true}>
                                 <button onClick={markAllAsRead}>Mark all as read</button>
                              </ConditionalBlock>
                           </div>
                        </div>
                        
                        <div className="notification-content">
                           {notifications?.length > 0 && notifications.map(({read,event,id},indx)=>{
                              return (
                                 <NotificationEvent key={indx} read={read} event={event} id={id} indx={indx} isOlder={false}/>
                              );
                           })}
                        </div>
                        {(yesterDay?.length >0 && frontLabel !== "Yesterday") &&
                           <div className='presentday-content'>
                              <div className='flex presentday-top-block'>
                                 <div className='notification-days'>Yesterday</div>
                              </div>
                           </div>
                        }
                        <div className="notification-content">
                           {yesterDay?.length>0 && yesterDay?.map(({read,event,id},indx)=>(
                              <NotificationEvent key={indx} read={read} event={event} id={id} indx={indx} isOlder={false}/>
                           ))}
                        </div>

                        {(older?.length >0 && frontLabel !== "Older") &&
                           <div className='presentday-content'>
                              <div className='flex presentday-top-block'>
                                 <div className='notification-days'>Older</div>
                              </div>
                           </div>
                        }
                        <div className="notification-content">
                           {older?.length>0 && older?.map(({read,event,id}, indx)=>(
                              <NotificationEvent key={indx} read={read} event={event} id={id} indx={indx} isOlder={true}/>
                        ))}
                        </div>
                     </div>
                  </ConditionalBlock>
                  <ConditionalBlock condition={frontLabel === ""}>
                     <NoDataFoundComponent />
                  </ConditionalBlock>
                  <ConditionalBlock condition={lastList === true}>
                     <AllData />
                  </ConditionalBlock>
               </div>
            </div>
      </div> 
    </>
  )
}

export default memo(Notifications);
